import { render } from "./App.vue?vue&type=template&id=39a554ef&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=39a554ef&lang=scss&scoped=true"

import exportComponent from "D:\\workSpan\\vue\\billow-global-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a554ef"]])

export default __exports__